<template>
  <!-- <b-row class="text-center"> -->
    <b-col md="3" sm="3" xl="3" class="animated fadeIn fadeOut">
      <b-card @click="detail(agent)" :style="{ cursor: 'pointer'}">
        <h4>
          <b-badge :variant="agent.fqdn ? 'info' : 'primary'">
            {{agent.fqdn ? '도메인' : '서버'}}
          </b-badge>
        </h4>
        <hr>
        <p class="ml-2 font-weight-bold">{{agent.name || '-'}}</p>
        <h6>{{agent.fqdn ? agent.fqdn : agent.ip_addr}}<br></h6>
        <hr>
        <b-badge v-if="agent.total_detect" variant="danger" @click="$router.push({ name : 'integrity_detect' })">Recent Detected : {{agent.total_detect}}</b-badge>
        <b-badge v-else-if="!agent.is_configured" variant="dark">미설정</b-badge>
        <b-badge v-else variant="success">Good</b-badge>
      </b-card>
      <!-- {{agent}} -->
    </b-col>

  <!-- </b-row> -->
</template>
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
